import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { API_URL } from 'src/app/shared/constants/apiurl-constants';
import { ExpenseSurvey } from 'src/app/shared/models/expense-survey';
import {SessionService} from 'src/app/shared/session-service/session.service';

@Injectable({
    providedIn: 'root'
})

export class ExpenseSurveyDetailsService {
    constructor(public sessionService: SessionService) { }
    private expenseSurveyDetails = new BehaviorSubject<ExpenseSurvey>(new ExpenseSurvey());
    expenseSurveyDetails$ = this.expenseSurveyDetails.asObservable();

    setExpenseSurveyDetails(expenseSurvey: ExpenseSurvey): void {
        this.expenseSurveyDetails.next(expenseSurvey);
    }

    getExpenseSMEsEmailSentDateDetails(surveyId: number, engagementId: number) {
        return this.sessionService.apiUrlGet(API_URL.EXPENSESURVEY.GET_EXPENSE_SME_EMAIL_SENT_DETAILS + `?surveyId=${surveyId}&engagementId=${engagementId}`);
    }
}
